define([
	"dojo/_base/array",
   	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action/Controller",
    "csi/xml",
    "./IssueRequestController"
], function(array,declare,lang,ActionController,xml,IssueRequestController) {

	return declare([ActionController,IssueRequestController], {
		getFormData: function() {
			var fd = this.inherited(arguments);
			fd.m_fAggregateTest = lang.hitch(this, this._canSelectSRLineItem);
			return fd;
		},

		_canSelectSRLineItem: function(/*Context*/ctx, /*FormData*/fd) {
			// allow SRLineItem for selection
			return !xml.isEmptyURL(ctx.getNode().SRLineItemProduct);
	    }
	});
});
